import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "./i18n";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { EditorialMarquee } from "./components/EditorialMarquee";
import { Manifesto } from "./components/Manifesto";
import { MenuSection } from "./components/MenuSection";
import { Combos } from "./components/Combos";
import { Gallery } from "./components/Gallery";
import { Reviews } from "./components/Reviews";
import { Visit } from "./components/Visit";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingCTAs } from "./components/FloatingCTAs";
import { Admin } from "./components/Admin";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-paper text-ink font-body min-h-screen" data-testid="sipsation-app">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <MenuSection />
        <Combos />
        <Gallery />
        <Reviews />
        <Visit />
        <Contact />
      </main>
      <Footer />
      <FloatingCTAs />
    </div>
  );
}

export default function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-left" />
    </LangProvider>
  );
}
